import FormItem from "@components/formItem";
import PaymentSelect from "@components/paymentSelect/index.jsx";
import { BETTER_BRO_CHILE_BANKS } from "@enums";
import { VALIDATION_RULES } from "@pages/profile-v2/utils";
import { getUser } from "@utils";
import React from "react";
import MaskInput from "react-maskinput";
import {
	Box,
	BoxTitle,
	Content,
	ContentTitle,
	ErrorInputWrapper,
	MaskedInput,
	MaskedInputLabel,
	StakeInput,
	StakeInputError,
} from "../baseItems";
import Base from "./base";

const PIX_KEY_TYPES = ["CPF", "CNPJ", "PHONE", "EMAIL", "EVP"];

export default class BetterBro extends Base {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			pixKeyError: "",
			pixKeyType: "",
			pixKey: "",
			receiver_clabe: "",
			bank_code: "",
			account_type: "",
			account_number: "",
			cbu_cvu: "",
			alias: "",
			argentinaIdentifierType: "cbu_cvu",
		};
	}

	onArgentinaIdentifierChange(field, e) {
		super.onEnterValue(field, e);
		const clearedField = field === "alias" ? "cbu_cvu" : "alias";
		this.setState(
			{
				[clearedField]: "",
				[`${clearedField}Value`]: "",
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	validatePixKey() {
		const { pixKeyType, pixKey } = this.state;

		if (!pixKeyType) {
			this.setState({ pixKeyError: "PIX_KEY_TYPE_REQUIRED" });
			return false;
		}

		if (!pixKey) {
			this.setState({ pixKeyError: "PIX_KEY_REQUIRED" });
			return false;
		}

		const rule = VALIDATION_RULES[pixKeyType];
		if (!rule.regex.test(pixKey)) {
			this.setState({ pixKeyError: rule.message });
			return false;
		}

		this.setState({ pixKeyError: "" });
		return true;
	}

	goForward(step) {
		const { method } = this.props;

		if (method === "BetterBroPix" && step === 1) {
			if (!this.validatePixKey()) {
				return;
			}
		}

		super.goForward(step);
	}

	getStep1(translate) {
		const { method } = this.props;
		const {
			selectedCurrency,
			pixKeyType,
			receiver_clabe,
			pixKey,
			pixKeyError,
			bank_code,
			account_type,
			account_number,
			cbu_cvu,
			alias,
			argentinaIdentifierType,
		} = this.state;

		const banks = BETTER_BRO_CHILE_BANKS;

		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				{this.getCurrencyField(translate)}
				{selectedCurrency &&
					selectedCurrency !== translate("PLEASE_SELECT") &&
					this.getStakeField()}
				{this.renderMinMax()}
				{method === "BetterBroPix" && (
					<>
						<FormItem onRegister={() => this.registerField({ name: "pixKeyType" })}>
							<Box>
								<BoxTitle>{translate("TYPE")}</BoxTitle>
								<PaymentSelect
									options={PIX_KEY_TYPES.map((item) => ({
										value: item,
										label: translate(`PIX_KEY_${item}`),
									}))}
									value={pixKeyType}
									handleSelect={(e) => {
										this.setState({
											pixKeyType: e.value,
											pixKey: "",
											pixKeyError: "",
										});
									}}
								/>
							</Box>
						</FormItem>
						{pixKeyType === "CPF" && (
							<FormItem onRegister={() => this.registerField({ name: "pixKey" })}>
								<Box>
									<ErrorInputWrapper>
										<MaskedInput>
											<MaskInput
												maskChar={"X"}
												mask="000.000.000-00"
												size={11}
												onChange={(e) => this.onEnterValue("pixKey", e)}
												value={pixKey}
											/>
											<MaskedInputLabel hasValue={pixKey}>
												{translate("CPF")}
											</MaskedInputLabel>
										</MaskedInput>
										{pixKeyError && (
											<StakeInputError>
												{translate(pixKeyError)}
											</StakeInputError>
										)}
									</ErrorInputWrapper>
								</Box>
							</FormItem>
						)}
						{pixKeyType === "CNPJ" && (
							<FormItem onRegister={() => this.registerField({ name: "pixKey" })}>
								<Box>
									<ErrorInputWrapper>
										<MaskedInput>
											<MaskInput
												maskChar={"X"}
												mask="00.000.000/\0\0\0\1-00"
												size={18}
												onChange={(e) => this.onEnterValue("pixKey", e)}
												value={pixKey}
											/>
											<MaskedInputLabel hasValue={pixKey}>
												{translate("CNPJ")}
											</MaskedInputLabel>
										</MaskedInput>
										{pixKeyError && (
											<StakeInputError>
												{translate(pixKeyError)}
											</StakeInputError>
										)}
									</ErrorInputWrapper>
								</Box>
							</FormItem>
						)}
						{pixKeyType === "PHONE" && (
							<FormItem onRegister={() => this.registerField({ name: "pixKey" })}>
								<Box>
									<BoxTitle>{translate("PHONE_NUMBER")}</BoxTitle>
									<ErrorInputWrapper>
										<StakeInput
											type="text"
											placeholder="+55XXXXXXXXXXX or XXXXXXXXXXX"
											onChange={this.onEnterValue.bind(this, "pixKey")}
											value={pixKey}
										/>
										{pixKeyError && (
											<StakeInputError>
												{translate(pixKeyError)}
											</StakeInputError>
										)}
									</ErrorInputWrapper>
								</Box>
							</FormItem>
						)}
						{pixKeyType === "EMAIL" && (
							<FormItem onRegister={() => this.registerField({ name: "pixKey" })}>
								<Box>
									<BoxTitle>{translate("EMAIL")}</BoxTitle>
									<ErrorInputWrapper>
										<StakeInput
											type="text"
											placeholder="example@mail.com"
											onChange={this.onEnterValue.bind(this, "pixKey")}
											value={pixKey}
										/>
										{pixKeyError && (
											<StakeInputError>
												{translate(pixKeyError)}
											</StakeInputError>
										)}
									</ErrorInputWrapper>
								</Box>
							</FormItem>
						)}
						{pixKeyType === "EVP" && (
							<FormItem onRegister={() => this.registerField({ name: "pixKey" })}>
								<Box>
									<BoxTitle>{translate("PIX_KEY_EVP")}</BoxTitle>
									<ErrorInputWrapper>
										<StakeInput
											type="text"
											placeholder="123e4567-e89b-12d3-a456-426614174000"
											onChange={this.onEnterValue.bind(this, "pixKey")}
											value={pixKey}
										/>
										{pixKeyError && (
											<StakeInputError>
												{translate(pixKeyError)}
											</StakeInputError>
										)}
									</ErrorInputWrapper>
								</Box>
							</FormItem>
						)}
					</>
				)}
				{method === "BetterBro SPEI" && (
					<FormItem onRegister={() => this.registerField({ name: "receiver_clabe" })}>
						<Box>
							<StakeInput
								autoFocus={true}
								placeholder={translate("Clabe")}
								value={receiver_clabe}
								onChange={this.onEnterValue.bind(this, "receiver_clabe")}
								onLoad={() => this.registerField({ name: "receiver_clabe" })}
							/>
						</Box>
					</FormItem>
				)}
				{method === "BetterBroChileBankTransfer" && (
					<>
						<FormItem onRegister={() => this.registerField({ name: "bank_code" })}>
							<Box>
								<BoxTitle>{translate("SELECT_BANK")}</BoxTitle>
								<PaymentSelect
									value={bank_code}
									options={(banks || []).map((item) => ({
										value: item.code,
										label: item.name,
									}))}
									handleSelect={(e) => this.setState({ bank_code: e.value })}
								/>
							</Box>
						</FormItem>
						<FormItem onRegister={() => this.registerField({ name: "account_type" })}>
							<Box>
								<BoxTitle>{translate("ACCOUNT_TYPE")}</BoxTitle>
								<PaymentSelect
									value={account_type}
									options={[
										{ value: "RUT", label: translate("RUT") },
										{ value: "VISTA", label: translate("VISTA") },
										{ value: "CHECKING", label: translate("CHECKING") },
										{ value: "SAVINGS", label: translate("SAVINGS") },
										{ value: "SALARY", label: translate("SALARY") },
									]}
									handleSelect={(e) => this.setState({ account_type: e.value })}
								/>
							</Box>
						</FormItem>
						<FormItem onRegister={() => this.registerField({ name: "account_number" })}>
							<Box>
								<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
								<StakeInput
									type="text"
									value={account_number}
									onChange={this.onEnterValue.bind(this, "account_number")}
								/>
							</Box>
						</FormItem>
					</>
				)}
				{method === "BetterBroArgentinaCbuCvu" && (
					<>
						<FormItem>
							<Box>
								<BoxTitle>{translate("TYPE")}</BoxTitle>
								<PaymentSelect
									value={argentinaIdentifierType}
									options={[
										{
											value: "receiver_clabe",
											label: translate("CbuCvu"),
										},
										{ value: "alias", label: translate("ALIAS") },
									]}
									handleSelect={(option) =>
										this.setState({
											argentinaIdentifierType: option.value,
											cbu_cvu: "",
											alias: "",
										})
									}
								/>
							</Box>
						</FormItem>
						{argentinaIdentifierType === "cbu_cvu" ? (
							<FormItem onRegister={() => this.registerField({ name: "cbu_cvu" })}>
								<Box>
									<BoxTitle>{translate("CbuCvu")}</BoxTitle>
									<StakeInput
										type="text"
										placeholder="22 digits"
										maxLength={22}
										value={cbu_cvu}
										onChange={(event) =>
											this.onArgentinaIdentifierChange("cbu_cvu", event)
										}
									/>
								</Box>
							</FormItem>
						) : (
							<FormItem onRegister={() => this.registerField({ name: "alias" })}>
								<Box>
									<BoxTitle>{translate("ALIAS")}</BoxTitle>
									<StakeInput
										type="text"
										placeholder="my.alias"
										value={alias}
										onChange={(event) =>
											this.onArgentinaIdentifierChange("alias", event)
										}
									/>
								</Box>
							</FormItem>
						)}
					</>
				)}
			</Content>
		);
	}

	makeExternalPayment() {
		const { method } = this.props;
		const {
			stake,
			pixKey,
			receiver_clabe,
			selectedCurrency,
			pixKeyType,
			bank_code,
			account_type,
			account_number,
			cbu_cvu,
			alias,
			argentinaIdentifierType,
		} = this.state;

		const methodPart = method.includes("BetterBro ")
			? method.split("BetterBro ")[1]
			: method.split("BetterBro")[1];

		let withdrawData;

		if (method === "BetterBro SPEI") {
			withdrawData = {
				method: methodPart,
				receiver_clabe: receiver_clabe,
				type: "BetterBro",
				username: getUser().username,
				amount: {
					value: stake,
					currency: selectedCurrency,
				},
				note: new Date(),
			};
		} else if (method === "BetterBroChileBankTransfer") {
			withdrawData = {
				type: methodPart,
				amount: {
					value: Number(stake),
					currency: selectedCurrency,
				},
				bank_code: bank_code,
				account_type: account_type,
				account_number: account_number,
			};
		} else if (method === "BetterBroArgentinaCbuCvu") {
			const identifierPayload =
				argentinaIdentifierType === "alias" ? { alias } : { receiver_clabe };
			withdrawData = {
				type: "BetterBro",
				method: methodPart,
				currency: selectedCurrency,
				amount: {
					value: stake,
					currency: selectedCurrency,
				},
				...identifierPayload,
			};
		} else {
			withdrawData = {
				method: methodPart,
				pixKey: pixKey,
				pixKeyType,
				type: "BetterBro",
				username: getUser().username,
				amount: {
					value: stake,
					currency: selectedCurrency,
				},
				note: new Date().toISOString(),
			};
		}

		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
